import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import Modal from '../components/Modal';
import api from '../services/api';
import SeguimientoPedido from '../components/pedidos/SeguimientoPedido';

const formatCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
/**
 * Los diez estados del recorrido de un pedido.
 *
 * Estaban solo los cuatro viejos, asi que un pedido «preparando» o «enviado» salia sin
 * etiqueta —un hueco en blanco— y no habia forma de filtrarlo. Justo los estados nuevos,
 * que son los que dicen que hay que hacer HOY.
 */
const EST = {
  nuevo:        { color:'#00E5FF', bg:'rgba(0,229,255,0.1)',   label:'🆕 Nuevo' },
  confirmado:   { color:'#F59E0B', bg:'rgba(245,158,11,0.1)',  label:'✅ Confirmado' },
  preparando:   { color:'#A78BFA', bg:'rgba(167,139,250,0.1)', label:'📋 Preparando' },
  listo:        { color:'#22D3EE', bg:'rgba(34,211,238,0.1)',  label:'📦 Listo' },
  enviado:      { color:'#3B82F6', bg:'rgba(59,130,246,0.12)', label:'🚚 Enviado' },
  en_reparto:   { color:'#FBBF24', bg:'rgba(251,191,36,0.12)', label:'🛵 En reparto' },
  entregado:    { color:'#10B981', bg:'rgba(16,185,129,0.1)',  label:'🏠 Entregado' },
  no_entregado: { color:'#FCA5A5', bg:'rgba(239,68,68,0.12)',  label:'⚠️ No se pudo' },
  devuelto:     { color:'#FDBA74', bg:'rgba(253,186,116,0.12)',label:'↩️ Devuelto' },
  cancelado:    { color:'#6B7280', bg:'rgba(107,114,128,0.1)', label:'✕ Cancelado' },
};

/**
 * El filtro se ordena por lo que hay que HACER, no por el ciclo entero.
 *
 * «Por despachar» junta los tres estados en que la mercancia todavia esta en la oficina:
 * es la pregunta de cada manana —que tengo que sacar hoy—. Antes habia que mirar tres
 * filtros por separado para saberlo.
 */
const FILTROS = ['', 'por_despachar', 'nuevo', 'confirmado', 'preparando', 'listo',
                 'enviado', 'en_reparto', 'entregado', 'no_entregado', 'devuelto', 'cancelado'];
const ETIQUETA_FILTRO = { '': 'Todos', por_despachar: '📤 Por despachar' };

export default function PedidosWeb() {
  const [pedidos, setPedidos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [detalle, setDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [vendedores, setVendedores] = useState([]);
  const [reparto, setReparto] = useState(null);   // cuánto deja el pedido abierto

  const cargar = useCallback(async () => {
    try {
      const { data } = await api.get(`/api/pedidos-web${filtro ? '?estado='+filtro : ''}`);
      setPedidos(data);
    } catch(e) {} finally { setCargando(false); }
  }, [filtro]);

  useEffect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); }, [cargar]);
  useEffect(() => { api.get('/api/vendedores').then(r => setVendedores(r.data.filter(v => v.activo))).catch(()=>{}); }, []);

  // Al abrir un pedido de la tienda se consulta cuánto deja, para poder mostrar el
  // reparto exacto antes de decidir quién se lleva la comisión.
  useEffect(() => {
    setReparto(null);
    if (detalle && detalle.tipo !== 'plan') {
      api.get(`/api/pedidos-web/${detalle.id}/ganancia`).then(r => setReparto(r.data)).catch(()=>{});
    }
  }, [detalle]);

  const cambiarEstado = async (id, estado) => {
    try {
      await api.put(`/api/pedidos-web/${id}/estado`, { estado });
      setDetalle(null); cargar();
    } catch(e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const asignarVenta = async (id, vendedor_id) => {
    try {
      const { data } = await api.put(`/api/pedidos-web/${id}/vendedor`,
        vendedor_id ? { vendedor_id } : { sin_vendedor: true });
      alert(data.mensaje);
      setDetalle(null); cargar();
    } catch(e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const nuevos = pedidos.filter(p => p.estado === 'nuevo').length;
  const sinClasificar = pedidos.filter(p => p.tipo !== 'plan' && !p.comision_definida && p.estado !== 'cancelado').length;

  return (
    <Layout>
      <div style={s.page}>
        <div style={s.topBar}>
          <div>
            <h1 style={s.h1}>🛒 Pedidos Web</h1>
            <p style={s.sub}>Pedidos de la tienda y solicitudes de instalación desde linkustelecom.com</p>
          </div>
          <div style={{display:'flex', gap:'10px', flexWrap:'wrap'}}>
            {nuevos > 0 && <div style={s.alertaNuevos}>{nuevos} pedido{nuevos>1?'s':''} nuevo{nuevos>1?'s':''} por atender</div>}
            {sinClasificar > 0 && (
              <div style={{...s.alertaNuevos, background:'rgba(99,102,241,0.15)', color:'#A5B4FC', border:'1px solid rgba(99,102,241,0.3)'}}>
                {sinClasificar} sin definir quién vendió
              </div>
            )}
          </div>
        </div>

        <div style={{display:'flex', gap:'8px', marginBottom:'18px', flexWrap:'wrap'}}>
          {FILTROS.map(e => (
            <button key={e} onClick={() => setFiltro(e)}
              style={{...s.filtroBtn, ...(filtro===e ? s.filtroOn : {})}}>
              {ETIQUETA_FILTRO[e] || EST[e]?.label || e}
            </button>
          ))}
        </div>

        {cargando ? <div style={s.vacio}>Cargando...</div> :
         pedidos.length === 0 ? <div style={s.vacio}>Sin pedidos {filtro && `en estado "${filtro}"`}. Cuando alguien compre en la tienda o solicite un plan, aparecerá aquí.</div> :
         <div style={s.lista}>
          {pedidos.map(p => (
            <div key={p.id} style={s.card} onClick={() => setDetalle(p)}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'10px', flexWrap:'wrap'}}>
                <div>
                  <div style={{display:'flex', gap:'8px', alignItems:'center', flexWrap:'wrap'}}>
                    <span style={s.numero}>{p.numero}</span>
                    <span style={{...s.badge, background:EST[p.estado]?.bg, color:EST[p.estado]?.color}}>{EST[p.estado]?.label}</span>
                    <span style={{...s.badge, background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.5)'}}>
                      {p.tipo === 'plan' ? '📶 Solicitud de plan' : '🛍️ Compra tienda'}
                    </span>
                    {p.pago_estado === 'aprobado' && <span style={{...s.badge, background:'rgba(16,185,129,0.15)', color:'#6EE7B7'}}>💳 PAGADO</span>}
                    {p.tipo !== 'plan' && p.estado !== 'cancelado' && (
                      p.comision_definida
                        ? <span style={{...s.badge, background:'rgba(99,102,241,0.12)', color:'#A5B4FC'}}>
                            {p.vendedor_nombre ? `👤 ${p.vendedor_nombre}` : '🌐 Vino solo'}
                          </span>
                        : <span style={{...s.badge, background:'rgba(251,191,36,0.15)', color:'#FDE047'}}>¿Quién vendió?</span>
                    )}
                  </div>
                  <div style={s.nombre}>{p.nombre} · 📞 {p.telefono}</div>
                  <div style={s.meta}>
                    {p.tipo === 'plan' ? p.plan_nombre : `${(p.items||[]).length} producto(s) · ${formatCOP(p.total)}`}
                    {p.municipio ? ` · ${p.municipio}` : ''}
                  </div>
                </div>
                <div style={s.fecha}>{new Date(p.creado_en).toLocaleString('es-CO', {day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit'})}</div>
              </div>
            </div>
          ))}
         </div>}

        {detalle && (
          <Modal abierto={true} onCerrar={() => setDetalle(null)} titulo={`${detalle.numero} — ${detalle.nombre}`} ancho="520px">
            <div style={{fontSize:'14px', color:'rgba(255,255,255,0.8)', lineHeight:'2'}}>
              <div><b>📞 Teléfono:</b> <a href={`tel:${detalle.telefono}`} style={{color:'#00E5FF'}}>{detalle.telefono}</a></div>
              {detalle.email && <div><b>✉️ Email:</b> {detalle.email}</div>}
              {detalle.municipio && <div><b>📍 Municipio:</b> {detalle.municipio}</div>}
              {detalle.direccion && <div><b>🏠 Dirección:</b> {detalle.direccion}</div>}
              {detalle.notas && <div><b>📝 Notas:</b> {detalle.notas}</div>}
              {detalle.metodo_pago && <div><b>💳 Método de pago:</b> {detalle.metodo_pago === 'mercadopago' ? `Mercado Pago ${detalle.pago_estado === 'aprobado' ? '— ✅ PAGADO' : '— pendiente'}` : 'Contra entrega'}</div>}
              {detalle.pago_estado === 'aprobado' && (
                <div style={{background:'rgba(16,185,129,0.08)', border:'1px solid rgba(16,185,129,0.3)', borderRadius:'10px', padding:'12px', marginTop:'10px', fontSize:'13px', lineHeight:'1.6'}}>
                  💳 <b>Este pedido ya está PAGADO por Mercado Pago</b>{detalle.mp_payment_id ? ` (pago #${detalle.mp_payment_id})` : ''}.<br/>
                  ✅ Siguiente paso: contactar al cliente y coordinar la entrega → luego marca <b>Entregado</b>.<br/>
                  ⚠️ Si necesitas cancelarlo, primero haz el reembolso en el panel de Mercado Pago.
                </div>
              )}
              {detalle.tipo === 'plan' ? (
                <div style={{background:'rgba(0,229,255,0.06)', border:'1px solid rgba(0,229,255,0.15)', borderRadius:'10px', padding:'12px', marginTop:'10px'}}>
                  <b>📶 Plan solicitado:</b><br/>{detalle.plan_nombre}
                </div>
              ) : (
                <div style={{marginTop:'10px'}}>
                  <b>🛍️ Productos:</b>
                  {(detalle.items||[]).map((it,i) => (
                    <div key={i} style={{display:'flex', justifyContent:'space-between', gap:'10px', padding:'7px 0', borderBottom:'1px solid rgba(255,255,255,0.06)', fontSize:'13px'}}>
                      <span style={{flex:1}}>{it.descripcion}</span>
                      <span style={{whiteSpace:'nowrap'}}>x{it.cantidad} · {formatCOP(it.subtotal)}</span>
                    </div>
                  ))}
                  <div style={{textAlign:'right', fontWeight:'800', fontSize:'17px', marginTop:'10px', color:'#10B981'}}>Total: {formatCOP(detalle.total)}</div>
                </div>
              )}

              {/* Quién trajo la venta. Define el reparto: con vendedor 70/25/5, y si el
                  cliente llegó solo no hay a quién pagarle ese 5%, que queda en la empresa. */}
              {detalle.tipo !== 'plan' && detalle.estado !== 'cancelado' && (
                <div style={{background:'rgba(99,102,241,0.06)', border:'1px solid rgba(99,102,241,0.22)', borderRadius:'10px', padding:'14px', marginTop:'14px'}}>
                  <div style={{fontSize:'13.5px', fontWeight:'700', color:'#A5B4FC', marginBottom:'4px'}}>
                    ¿Quién trajo esta venta?
                  </div>

                  {detalle.comision_definida ? (
                    <div style={{fontSize:'13px', color:'rgba(255,255,255,0.7)', lineHeight:'1.7'}}>
                      {detalle.vendedor_nombre
                        ? <>La vendió <b style={{color:'#fff'}}>{detalle.vendedor_nombre}</b>.</>
                        : <>El cliente llegó solo a la página.</>}
                      <div style={{marginTop:'6px', fontSize:'12.5px', color:'rgba(255,255,255,0.45)'}}>
                        Ganancia {formatCOP(detalle.ganancia)} · empresa {formatCOP(detalle.comision_empresa)} ·
                        equipo {formatCOP(detalle.comision_equipo)}
                        {Number(detalle.comision_vendedor) > 0 && <> · vendedor {formatCOP(detalle.comision_vendedor)}</>}
                      </div>
                      <button style={{...s.accion, background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.6)', marginTop:'10px', fontSize:'12px'}}
                        onClick={() => setDetalle({ ...detalle, comision_definida: false })}>
                        Cambiar
                      </button>
                    </div>
                  ) : (
                    <>
                      <div style={{fontSize:'12.5px', color:'rgba(255,255,255,0.45)', marginBottom:'10px', lineHeight:'1.6'}}>
                        {reparto
                          ? <>Deja <b style={{color:'#4ADE80'}}>{formatCOP(reparto.ganancia)}</b> de ganancia.
                              {/* El envío aparte: si la transportadora cobró más de lo que se le
                                  cobró al cliente, la ganancia baja y sin esto nadie entiende
                                  por qué no cuadra con los productos. */}
                              {Number(reparto.envio) !== 0 && (
                                <> ({formatCOP(reparto.ganancia_productos)} de los productos
                                  {Number(reparto.envio) > 0
                                    ? <> y {formatCOP(reparto.envio)} que dejó el envío</>
                                    : <>, menos {formatCOP(Math.abs(Number(reparto.envio)))} que costó el envío de más</>})</>
                              )}
                              {' '}Con vendedor: empresa {formatCOP(reparto.con_vendedor.comision_empresa)},
                              equipo {formatCOP(reparto.con_vendedor.comision_equipo)},
                              vendedor {formatCOP(reparto.con_vendedor.comision_vendedor)}.
                              Sin vendedor: empresa {formatCOP(reparto.sin_vendedor.comision_empresa)},
                              equipo {formatCOP(reparto.sin_vendedor.comision_equipo)}.
                              {/* Un renglón sin costo se cuenta con ganancia cero. Decirlo, porque
                                  sobre esta cifra se le paga al vendedor. */}
                              {reparto.sin_costo > 0 && (
                                <div style={{marginTop:'7px', color:'#FDBA74'}}>
                                  ⚠️ {reparto.sin_costo} de los {reparto.renglones} renglones no
                                  guardaron su costo y se contaron sin ganancia: la real es mayor
                                  que la de arriba.
                                </div>
                              )}</>
                          : 'Calculando cuánto deja este pedido...'}
                      </div>
                      <div style={{display:'flex', gap:'7px', flexWrap:'wrap'}}>
                        {vendedores.map(v => (
                          <button key={v.id} style={{...s.accion, background:'rgba(99,102,241,0.15)', color:'#A5B4FC', fontSize:'12.5px'}}
                            onClick={() => asignarVenta(detalle.id, v.id)}>
                            👤 {v.nombre}
                          </button>
                        ))}
                        <button style={{...s.accion, background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.65)', fontSize:'12.5px'}}
                          onClick={() => asignarVenta(detalle.id, null)}>
                          🌐 Llegó solo a la página
                        </button>
                      </div>
                      {vendedores.length === 0 && (
                        <div style={{fontSize:'12px', color:'#FDE047', marginTop:'8px'}}>
                          No hay vendedores activos. Agrégalos en la pantalla de Vendedores.
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            {/* Los tres botones sueltos de antes —confirmar, entregado, cancelar— no daban
                forma de saber por donde iba la mercancia. Ahora el recorrido completo, con
                su historial: es lo que se le contesta al cliente que llama a preguntar. */}
            {/* Al cambiar de paso se refresca la lista de atrás pero la ventana SE QUEDA
                abierta: un pedido se mueve varios pasos seguidos —confirmar, preparar,
                despachar— y cerrarla en cada uno obligaba a buscarlo y abrirlo de nuevo
                cada vez. */}
            <SeguimientoPedido pedidoId={detalle.id} alCambiar={cargar} />
          </Modal>
        )}
      </div>
    </Layout>
  );
}

const s = {
  page:   { padding:'24px', maxWidth:'1000px', margin:'0 auto' },
  topBar: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px', flexWrap:'wrap', gap:'12px' },
  h1:     { fontSize:'22px', fontWeight:'700', color:'#fff' },
  sub:    { fontSize:'13px', color:'rgba(255,255,255,0.4)' },
  alertaNuevos: { background:'rgba(0,229,255,0.1)', border:'1px solid rgba(0,229,255,0.3)', color:'#00E5FF', borderRadius:'10px', padding:'9px 16px', fontSize:'13px', fontWeight:'700' },
  filtroBtn: { background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'20px', padding:'7px 16px', color:'rgba(255,255,255,0.5)', fontSize:'12.5px', cursor:'pointer', fontWeight:'600' },
  filtroOn:  { background:'rgba(0,229,255,0.12)', border:'1px solid rgba(0,229,255,0.35)', color:'#00E5FF' },
  lista:  { display:'flex', flexDirection:'column', gap:'10px' },
  card:   { background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'14px', padding:'16px 18px', cursor:'pointer' },
  numero: { fontWeight:'800', color:'#fff', fontSize:'14px' },
  badge:  { fontSize:'11px', fontWeight:'700', padding:'3px 10px', borderRadius:'12px' },
  nombre: { fontSize:'14px', color:'rgba(255,255,255,0.85)', marginTop:'6px', fontWeight:'600' },
  meta:   { fontSize:'12.5px', color:'rgba(255,255,255,0.45)', marginTop:'2px' },
  fecha:  { fontSize:'12px', color:'rgba(255,255,255,0.35)', whiteSpace:'nowrap' },
  vacio:  { textAlign:'center', color:'rgba(255,255,255,0.35)', padding:'60px 20px', fontSize:'14px' },
  accion: { border:'none', borderRadius:'10px', padding:'11px 18px', fontSize:'13px', fontWeight:'700', cursor:'pointer', flex:'1 1 auto' },
};
